import querystring from 'query-string'
import { simpleNotification } from '@halo/_utils/notifications'
import { axiosFetch, isAxiosResponseError } from '@halo/_utils/axios'
import aqe from '@pushly/aqe'
import { IApiResponse } from '@pushly/aqe/lib/interfaces'

export function accountIsBillable(account: any): boolean {
    return (
        !!account &&
        !!account.billing_data &&
        account.billing_data.type === 'CREDIT' &&
        !!account.billing_data.stripe_customer_id
    )
}

export async function fetchBillingRecordsByAccountId(
    accountId: number,
    opts: any = {},
    cancellationKey?: string,
): Promise<IApiResponse<any[]>> {
    let ok = false
    let invoices: any = []
    let meta: any

    const options = querystring.stringify(opts || {})
    const serviceURL = `${aqe.defaults.internalApiDomain}/v1/accounts/${accountId}/billing-records?${options}`

    try {
        const req = await axiosFetch('get', { url: serviceURL }, cancellationKey)

        ok = true
        invoices = req.data.data
        meta = req.data.meta
    } catch (error) {
        if (isAxiosResponseError(error)) {
            simpleNotification('error', error.response.data.message)
        }
    }

    return { ok, data: invoices, meta }
}

export async function fetchSubscriberHistoryByAccountId(
    accountId: number,
    opts?: any,
    cancellationKey?: string,
): Promise<IApiResponse<any[]>> {
    let ok = false
    let records: any[] = []
    let meta: any

    const options = querystring.stringify(opts || {})
    const serviceURL = `${aqe.defaults.internalApiDomain}/v1/accounts/${accountId}/subscriber-history?${options}`

    try {
        const req = await axiosFetch('get', { url: serviceURL }, cancellationKey)

        ok = true
        records = req.data.data
        meta = req.data.meta
    } catch (error) {
        if (isAxiosResponseError(error)) {
            simpleNotification('error', error.response.data.message)
        }
    }

    return { ok, data: records, meta }
}
